export default __webpack_public_path__ + "static/verse-x2x-lg-4073f8f687d7162aa048e64c51f540e0.png";